import React from "react";
import Marquee from "react-fast-marquee";

const WORDS = ["Velocity Detailing Co", "Precision", "Ceramic Shine", "Interior Reset", "Performance", "Concours Finish"];

export const TextMarquee = () => (
  <section data-testid="marquee" className="border-y border-white/10 bg-black py-6">
    <Marquee speed={40} gradient={false} autoFill>
      {WORDS.map((w, i) => (
        <div key={i} className="flex items-center">
          <span className={`px-8 font-cabinet text-4xl font-black uppercase tracking-tight md:text-6xl ${i % 2 === 0 ? "gradient-text" : "text-zinc-800"}`}>
            {w}
          </span>
          <span className="h-2 w-2 rotate-45 gradient-fill" />
        </div>
      ))}
    </Marquee>
  </section>
);
